/**
 * @import { PlaceInfo } from '@/features/world-map/types/place-info'
 */

import { useState } from 'react';
import { PlaceInfoContext } from '../context/place-info';

/**
 * @param {object} props
 * @param {React.ReactNode} props.children
 * @returns {React.JSX.Element}
 */

export const PlaceInfoProvider = ({ children }) => {
  const [placeInfo, setPlaceInfo] = useState(/** @type {PlaceInfo | null} */ (null));

  return <PlaceInfoContext.Provider value={{ placeInfo, setPlaceInfo }}>{children}</PlaceInfoContext.Provider>;
};
